// dependencies
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { Spinner } from "@performyard/py-components";

import Text from "../../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../../components/Card";
import SatisfactionMeter from "../../components/SatisfactionMeter";
// css
import css from "../../components/SatisfactionMeter/SatisfactionMeter.module.scss";

// overview store
import useStore from "../../../../../store";

// hooks
import { useFactorsSummary, useOverallSummary } from "../../../../../../../api/hooks";

// config
import Config from "../../../../../Config";

const SummaryDisplay = () => {
	// setup
	const [filter] = useStore((state) => [state.filter]);

	const binSize = Config.BIN_SIZE;

	// summary queries change with the filter:
	const {
		data: overallSummary,
		isLoading: isScoreLoading,
		error: scoreError,
	} = useOverallSummary({ startDate: filter.startDate, endDate: filter.endDate, binSize });
	const {
		data: allFactorsData,
		isLoading: isFactorsLoading,
		error: factorsError,
	} = useFactorsSummary({ startDate: filter.startDate, endDate: filter.endDate, overall: "true" });

	const overallAverage = useMemo(() => {
		if (allFactorsData?.data) {
			const total = allFactorsData.data.reduce((acc, cur) => acc + cur.average, 0);
			return total / allFactorsData.data.length;
		}
		return 0;
	}, [allFactorsData?.data]);

	return (
		<div className={css.summary}>
			{scoreError || factorsError ? (
				<Text size="paragraph-3" weight="regular">
					Error fetching score
				</Text>
			) : (
				<>
					{isScoreLoading || isFactorsLoading ? (
						<span className={`${css.spinRow} ${css.score}`}>
							<Spinner size={20} />
						</span>
					) : overallSummary?.data ? (
						<SatisfactionMeter overallAverage={overallAverage} monthlyData={overallSummary?.data} />
					) : null}
				</>
			)}
		</div>
	);
};

const Overall = () => {
	// setup
	const navigate = useNavigate();

	// render card
	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-3" weight="regular">
							Satisfaction
						</Text>{" "}
						<Text element="span" size="paragraph-3" weight="bold">
							Score
						</Text>
					</span>
				}
				info="Average overall satisfaction across all factors."
				options={[
					{
						id: "view-factors",
						label: "Factors",
						action: () => {
							// navigate to /engagement/factors page
							navigate(Config.ROUTES.FACTORS.url);
						},
					},
				]}
				style={{ paddingBottom: "16px" }}
			/>
			<CardBody>
				<div className={css.cardBody}>
					<SummaryDisplay />
				</div>
			</CardBody>
		</>
	);
};

export default Overall;
